"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function convertToMinutes() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (time.length) {
    var hours = time.split(':')[0];
    var minutes = time.split(':')[1];
    return parseInt(hours * 60, 10) + parseInt(minutes, 10);
  }
  return 0;
}
var _default = exports["default"] = convertToMinutes;